import { librarySettingsSerializer } from '@/providers/serializers/library/library';
import {Vue} from 'vue-property-decorator';
import { http } from '../http';

export class LibrarySettingsAPI extends Vue {

    public static INSTANCE = new LibrarySettingsAPI();

    static get instance() {
        return this.INSTANCE;
    }

    private namespace: string = 'api/nucleus/v2/libraries';

    public fetchLibraryItemList() {
        const endpoint = `${this.namespace}`;
        const header = http.getTokenHeaders();

        return http.get(endpoint, header).then((response) => {
            return librarySettingsSerializer.serializeLibraryList(response.data);
        });
    }

    public fetchLibraryItemListTenentAndOpen() {
        const endpoint = `${this.namespace}`;
        const header = http.getTokenHeaders();

        return http.get(endpoint, header).then((response) => {
            return librarySettingsSerializer.serializeLibraryListTenantOpen(response.data);
        });
    }

}

export const librarySettingsAPI = LibrarySettingsAPI.instance;
